export const compareByName = (a, b) => {
  const an = (a.name || "").toUpperCase();
  const bn = (b.name || "").toUpperCase();

  if (an < bn) { return -1; }
  if (an > bn) { return 1; }
    
  return 0;
}